(function () {
  'use strict';

  const grid = document.querySelector('[data-beat-grid]');
  if (!grid) return;

  const searchInput = document.querySelector('[data-beat-search]');
  const sortSelect = document.querySelector('[data-beat-sort]');

  function getRows() {
    return Array.from(grid.querySelectorAll('[data-beat-row]'));
  }

  function filterRows() {
    const query = (searchInput?.value || '').toLowerCase().trim();

    getRows().forEach(function(row) {
      var title = (row.dataset.title || '').toLowerCase();
      var matchesSearch = !query || title.includes(query);
      row.classList.toggle('is-hidden', !matchesSearch);
    });
  }

  function sortRows() {
    var value = sortSelect?.value || 'default';
    if (value === 'default') return;

    var rows = getRows();
    var parts = value.split('-');
    var field = parts[0];
    var dir = parts[1];

    rows.sort(function(a, b) {
      var va, vb;
      if (field === 'title') {
        va = a.dataset.title || '';
        vb = b.dataset.title || '';
        return dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
      }
      if (field === 'bpm') {
        va = parseInt(a.dataset.bpm || '0');
        vb = parseInt(b.dataset.bpm || '0');
      }
      return dir === 'asc' ? va - vb : vb - va;
    });

    rows.forEach(function(row) { grid.appendChild(row); });
  }

  if (searchInput) searchInput.addEventListener('input', filterRows);
  if (sortSelect) sortSelect.addEventListener('change', function() { sortRows(); filterRows(); });
})();
